import './styles/fonts.css';
import './styles/app.css';

import './scene/geometry.js';
import './scene/textures.js';
import './scene/objects.js';
import './scene/gizmo.js';
import './ui/site-view.js';
import './ui/interaction.js';
import './ui/controls.js';
import './ui/mask-editor.js';

import { frameOrbit, isSiteLike } from './scene/cameras.js';
import { renderer } from './scene/context.js';
import { rebuildHelpers } from './scene/helpers.js';
import { buildEnvironment, setShadowRes, setShadowSoft } from './scene/lighting.js';
import * as _lighting from './scene/lighting.js';
import { fitStage } from './scene/renderer.js';
import { requestRender } from './state/bus.js';
import { resetHistory } from './state/history.js';
import { $, S } from './state/store.js';
import { fitPhoto, paintHandles, setChip } from './ui/calibrate-view.js';
import { goStage, setGizmoMode } from './ui/rails.js';
import { toast } from './ui/toast.js';

import * as _analytics from './services/analytics.js';
import * as _calibrate from './core/calibrate.js';
import * as _doc from './core/doc.js';
import * as _geometry from './scene/geometry.js';
import * as _objects from './scene/objects.js';
import * as _renderer from './scene/renderer.js';
import * as _bus from './state/bus.js';
import * as _anim from './core/anim.js';
import * as _movesCore from './core/moves.js';
import * as _moves from './state/moves.js';
import * as _timeline from './state/timeline.js';
import * as _timelineView from './ui/timeline-view.js';
import * as _mp4 from './export/mp4.js';
import * as _video from './scene/video.js';
import * as _videoTime from './core/video-time.js';
import * as _cropMap from './core/crop-map.js';
import * as _cameras from './scene/cameras.js';
import * as _calibrateView from './ui/calibrate-view.js';
import { syncCamRig } from './ui/camrig.js';
import * as _siteView from './ui/site-view.js';
import * as _videoImport from './scene/video-import.js';
import * as _replaceSource from './scene/replace-source.js';
import * as _onsite from './export/onsite.js';
import * as _mediaStore from './services/media-store.js';
import * as _history from './state/history.js';
import * as _rails from './ui/rails.js';
import * as _context from './scene/context.js';
import * as _fonts from './scene/fonts.js';
import * as _fontsCore from './core/fonts.js';
import * as _gizmo from './scene/gizmo.js';
import * as _helpers from './scene/helpers.js';
import * as _panels from './scene/panels.js';
import * as _mask from './core/mask.js';
import * as _maskEditor from './ui/mask-editor.js';
import * as _textarea from './scene/textarea.js';
import * as _projects from './services/projects.js';
import { restoreLastProject } from './services/projects.js';
import * as _projectsDb from './services/projects-db.js';
import * as _projectsFs from './services/projects-fs.js';
import * as _limits from './services/limits.js';
import * as _motion from './services/motion.js';
/* The APP's instance, for tools/verify.mjs. Importing ui/account.js there
   would hand back a second copy with its own overlay element — the exact
   hazard the note below this block describes. */
import * as _account from './ui/account.js';
import * as _auth from './services/auth.js';
import * as _feedback from './services/feedback.js';
import * as _supabase from './services/supabase.js';
import './ui/turn-banner.js';
import { initAccount, initProjects } from './ui/account.js';
import { initConsent } from './ui/consent.js';
import { initBilling } from './ui/billing.js';
import * as _billing from './ui/billing.js';
import { initFeedback } from './ui/feedback.js';
import { initAdmin } from './ui/admin.js';
import { initMobileNotice, isTouchOnly } from './ui/mobile-notice.js';
import { bootAdminOnly } from './ui/admin-only.js';
import './scene/video-import.js';   // binds #fileVideo's picker
import { initExport } from './ui/export-view.js';
import { initSettings } from './ui/settings.js';
import { initTimeline } from './ui/timeline-view.js';
import { initTemplates } from './ui/templates.js';
import { initTheme } from './ui/theme.js';
import * as _theme from './ui/theme.js';
import { preloadDefault } from './scene/fonts.js';


/* ═══════════════════════════════════════════════════════════
   BOOT
   ═══════════════════════════════════════════════════════════ */
// A resize repositions the same corner values on screen — it never moves
// them, so it must not un-solve a calibration that never actually changed.
new ResizeObserver(()=>{ fitStage(); if(S.photo && S.stage==='calib'){ fitPhoto(); paintHandles(false); } if(isSiteLike()) requestRender(); })
  .observe($('#stage'));
addEventListener('resize', ()=>{ fitStage(); if(S.photo){ fitPhoto(); paintHandles(false); } });

rebuildHelpers();
/* On a touch-only device, show the block instead of running the boot.

   Be precise about what this does and does not save. It skips the boot
   SEQUENCE — environment, shadow maps, font preload, project restore, every
   init below — but not the module graph: the imports at the top of this file
   have already run, and scene/context.js creates the WebGLRenderer at import
   time. A phone still downloads and evaluates the bundle. Skipping that too
   would mean the entry point not importing the app at all and pulling it in
   dynamically, which is a real change and not one to smuggle in here.

   isTouchOnly() reads two media queries and one navigator field, so it costs
   nothing and cannot throw — it catches internally and answers false, which
   fails towards letting people in rather than locking them out. */
/* ?admin — the Admin panel, and nothing else, on any device.

   It comes BEFORE the touch-only wall on purpose. Reading a trial request and
   granting a licence are list-and-button work with no mouse in them, so the
   reason the builder is desktop-only does not apply to Admin, and being unable
   to answer somebody away from a desk is a real cost with no matching reason.

   Not device-conditional either: one URL that behaves the same everywhere is
   easier to bookmark and, more usefully, testable at a phone width on a
   desktop. See ui/admin-only.js for why this is a separate boot rather than
   the app with the wall lifted. */
/* /unwrap — the Unwrap tool, and nothing else. Like ?admin it is a boot of its own: no scene,
   no builder, and it works on any device. Pages serves index.html for an unknown path (there is no
   404.html), so the address needs no server rule; illusio3d.com/unwrap redirects here
   (landing/public/_redirects). Loaded on demand so the builder's bundle does not carry it. */
if (/^\/unwrap\/?$/.test(location.pathname)) {
  import('./unwrap/page.js').then(m => m.bootUnwrap()).catch(err => window.__showFatal('unwrap', err));
  window.__booted = true;
} else if (new URLSearchParams(location.search).has('admin')) {
  bootAdminOnly();
  window.__booted = true;
} else if (isTouchOnly()) {
  initMobileNotice();
  window.__booted = true;     // the smoke tests only ask that boot completed
} else
try{
  buildEnvironment();
  setShadowRes(S.shadowRes);
  setShadowSoft(S.shadowSoft);
  frameOrbit();
  fitStage();
  goStage('calib');
  setGizmoMode('move');
  resetHistory();
  setChip('', 'Not calibrated');
  /* Warm the default face. Text is TRACED, so a face that has not loaded is
     traced as a fallback — buildText corrects itself when the real one arrives,
     but starting warm means the first text object never flashes the wrong
     letterforms. */
  preloadDefault();
  initProjects();         // same reasoning — local Save/Open project needs no account either
  initSettings();
  initExport();
  initTimeline();
  initFeedback();     // and this one is deliberately reachable without an account too
  /* Re-checked on every auth change, not just at boot: signing in is exactly
     the moment an account becomes an admin, and the unread count goes stale
     as soon as anything is marked read from another tab. */
  const refreshAdmin = initAdmin();
  if (refreshAdmin) _bus.on('auth:changed', refreshAdmin);
  initTheme();
  /* Last, so it sits over a settled page rather than appearing mid-boot. */
  initConsent();
  window.__booted = true;
}catch(err){
  window.__showFatal('boot', err);
  throw err;
}

/* Accounts come up after the scene, not before it. Restoring a session means a
   network round trip, and the app has to be usable while that is in flight —
   nobody should watch a spinner to draw a box. A build with no Supabase
   credentials skips this entirely and behaves as the single-file version did. */
/* And then put back whatever was open. After initAccount, not beside it: the
   restore is a cloud read and needs the session that initAccount is in the
   middle of establishing. It declines by itself if there is nothing to restore,
   nobody signed in, or anything already on the scene — see restoreLastProject. */
initAccount()
  .then(() => restoreLastProject())
  .catch(err => console.error('[illusio] account init failed', err));
// Mounted right after: initAccount's own toolbar mounting runs synchronously
// before its first await, so #acctChip already exists by the time these run,
// giving a clean, deterministic topbar order.
initBilling();
initTemplates();
syncCamRig();     // the On-site viewpoint rig, hidden until there is one to move

/* A dev-only handle on the module graph, for tools/verify.mjs.

   The test drives the app through this rather than calling import() itself,
   because Vite appends a ?t= timestamp to a module after an HMR update — so a
   fresh import('/src/state/store.js') can hand back a SECOND instance with its
   own copy of S, and every assertion then reads state the app never touched.
   import.meta.env.DEV is compiled to false in a build, so this disappears. */
if (import.meta.env.DEV) window.__illusio = {
  S, bus: _bus, calibrate: _calibrate, context: _context, doc: _doc,
  fonts: _fonts, fontsCore: _fontsCore, geometry: _geometry, gizmo: _gizmo, helpers: _helpers,
  panels: _panels, theme: _theme,
  history: _history, lighting: _lighting, mask: _mask, maskEditor: _maskEditor, objects: _objects, textarea: _textarea,
  projects: _projects, projectsDb: _projectsDb, projectsFs: _projectsFs, billing: _billing, limits: _limits, motion: _motion, account: _account,
  auth: _auth, feedback: _feedback, supabase: _supabase, analytics: _analytics,
  anim: _anim, timeline: _timeline, timelineView: _timelineView, mp4: _mp4,
  moves: _moves, movesCore: _movesCore,
  video: _video, videoTime: _videoTime, cropMap: _cropMap, cameras: _cameras, calibrateView: _calibrateView, videoImport: _videoImport, mediaStore: _mediaStore,
  replaceSource: _replaceSource,
  rails: _rails, renderer: _renderer, siteView: _siteView, onsite: _onsite
};

